import React from 'react';
import { Tabs } from '@clockout-dev/design-elements';
import ProductOrStateRulesPanel from '../../productOrStateRules/ProductOrStateRulesPanel';
import { CAP_RULE_TAB_KEYS, CAP_RULE_TABS } from '../limitsForm.constants';
import styles from '../styles/limitsForm.module.scss';

/**
 * The adjustments of a cap card, one tab each: tenure (the card's own rows),
 * product types and geography. The active tab lives in the Limits
 * controller's state (`activeKey` / `onChange`).
 *
 * Props:
 * - `tenurePanel` — the card's tenure rows and add button
 * - `productTypes`, `geography` — `{ rules, options, onAdd, onRemove, onUpdate }`
 * - `valueLabel`, `valueSuffixLabel`, `inputProps`, `inputClassName` — the cap value field
 */
function CapRulesTabs({
    activeKey,
    onChange,
    tenurePanel,
    productTypes = {},
    geography = {},
    valueLabel,
    valueSuffixLabel,
    inputProps,
    inputClassName,
}) {
    const ruleProps = {
        valueKey: 'value',
        valueLabel,
        valueSuffixLabel,
        inputProps,
        classNames: {
            row: styles.ruleRow,
            label: styles.ruleLabel,
            select: `${styles.select} ${styles.selectMd}`,
            input: `${styles.inlineNumberInput} ${inputClassName}`,
        },
    };

    const panel = {
        [CAP_RULE_TAB_KEYS.TENURE]: tenurePanel,
        [CAP_RULE_TAB_KEYS.PRODUCT_TYPES]: (
            <ProductOrStateRulesPanel
                {...ruleProps}
                {...productTypes}
                matchKey="productType"
                prefix="if a user has the product"
                addLabel="Add a product type row"
                emptyTitle="No product type rules yet"
                emptyDescription="Add a row to set this cap by the products a user holds."
            />
        ),
        [CAP_RULE_TAB_KEYS.GEOGRAPHY]: (
            <ProductOrStateRulesPanel
                {...ruleProps}
                {...geography}
                matchKey="states"
                prefix="if a user lives in"
                addLabel="Add a state row"
                emptyTitle="No state rules yet"
                emptyDescription="Add a row to set this cap by the state a user lives in."
            />
        ),
    };

    return (
        <>
            <Tabs
                activeKey={activeKey}
                onChange={onChange}
                items={CAP_RULE_TABS.map((tab) => ({ key: tab.key, label: tab.label }))}
                className={styles.adjustmentTabs}
            />
            {panel[activeKey]}
        </>
    );
}

export default CapRulesTabs;
